module.exports = __webpack_public_path__ + "img/aurora-rectangle-side-angle.81f4fa2c.png";